export default {"src":"/_next/static/media/logo.31071f8f.svg","height":89,"width":800,"blurWidth":0,"blurHeight":0};